import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

interface State {
    countryId: string,
    phone: string,
    userId: string,
    userName: string,
    token: string,
    userProfile: string,
    currentDocId: number,
    currentInvoice: Doc | null,
    searchDocId: number | null,
    searchBrand: string,
    docs: Doc[],
    searchCount: number,
    countries: Country[],
    landCountries: LandCountry[],
    invoiceTypes: InvoiceType[],
    invoiceStatuses: InvoiceStatus[],
    taskTypes: TaskType[],
    paymentTypes: PaymentType[],
}

export interface Country {
    id: string;
    name: string;
    portalUrl: string;
}

export interface LandCountry {
    id: string;
    name: string;
    parentCountry: string;
}

export interface Customer {
    id: number;
    name: string;
    manager_id: number;
    engineer_id: number;
}

export interface LegalEntity {
    id: number;
    customer_id: number;
    name: string;
    name_official: string;
    inn: string;
    kpp: string;
    create_date: Date;
    franchise_id: number;
}

export interface Department {
    id: number;
    customer_id: number;
    name: string;
}

export interface Contract {
    id: number;
    name: string;
    number: string;
    sign_date: Date;
    legal_entity_id: number;
    franchise_id: number;
}

export interface Franchise {
    id: number;
    name: string;
    name_official: string;
    inn: any;
    kpp: number;
    vat_rate: number;
}

export interface FranchiseBankAccount {
    id: number;
    franchise_id: number;
    bank_bik: number;
    bank_name: string;
    account_number: string;
    name: string;
}

export interface Manager {
    id: number;
    surname: string;
    first_name: string;
    middle_name: string;
    phone_number: any;
}

export interface Signer {
    id: number;
    surname: string;
    first_name: string;
    middle_name: string;
    phone_number: any;
}

export interface ItemTemplate {
    id: number;
    name: string;
}

export interface InvoiceType {
    id: number;
    name: string;
}

export interface InvoiceStatus {
    id: number;
    name: string;
}

export interface TaskType {
    id: number;
    name: string;
}

export interface PaymentType {
    id: number;
    name: string;
}

export interface Doc {
    id: number;
    number: string;
    external_id: number;
    status: number;
    summ: number;
    cancelled: boolean;
    summ_gen: number;
    gen_type: number;
    sum_diff: number;
    agregation: string;
    bill_type: number;
    guid: string;
    legal_entity_id: number;
    doc_type: number;
    signer_id: number;
    customer_id: number;
    department_id: number;
    branch_id: number;
    payment_type_id: number;
    franchise_id: number;
    bank_account_id: number;
    doc_date: Date;
    due_date: Date;
    manager_id: number;
    contract_id: number;
    vat_rate: number;
    doc_year: number;
    doc_month: number;
    sum_performer: number;
    customer: Customer;
    legal_entity: LegalEntity;
    department: Department;
    contract: Contract;
    franchise: Franchise;
    franchise_bank_account: FranchiseBankAccount;
    manager: Manager;
    signer: Signer;
    item_template: ItemTemplate;
}

export interface Invoice {
    id: number;
    number: string;
    external_id: number;
    status: number;
    summ: number;
    cancelled: boolean;
    summ_gen: number;
    gen_type: number;
    sum_diff: number;
    agregation: string;
    bill_type: number;
    guid: string;
    legal_entity_id: number;
    doc_type: number;
    signer_id: number;
    customer_id: number;
    department_id: number;
    branch_id: number;
    payment_type_id: number;
    franchise_id: number;
    bank_account_id: number;
    doc_date: Date;
    due_date: Date;
    manager_id: number;
    contract_id: number;
    vat_rate: number;
    doc_year: number;
    doc_month: number;
    sum_performer: number;
    customer: Customer;
    legal_entity: LegalEntity;
    department: Department;
    contract: Contract;
    franchise: Franchise;
    franchise_bank_account: FranchiseBankAccount;
    manager: Manager;
    signer: Signer;
    item_template: ItemTemplate;
}


const countries = [
    {id: "ru", name: "Россия", portalUrl: "wowworks.ru"},
    {id: "by", name: "Беларусь", portalUrl: "wowworks.by"},
    {id: "de", name: "Deutschland", portalUrl: "eu.wowworks.org"},
];

const landCountries = [
    {id: "Russia", name: "Россия", parentCountry: "ru"},
    {id: "Germany", name: "Германия", parentCountry: "de"},
    {id: "Austria", name: "Австрия", parentCountry: "de"},
    {id: "Poland", name: "Польша", parentCountry: "de"},
    {id: "Netherlands", name: "Нидерланды", parentCountry: "de"},
    {id: "Belarus", name: "Беларусь", parentCountry: "by"},
];

const invoiceTypes = [
    {id: 1, name: "Закрывающий документ"},
    {id: 2, name: "Авансовый счет"},
    {id: 3, name: "Gutschrift"},
    {id: 4, name: "Storno"},
    {id: 5, name: "Subscription"},
    {id: 6, name: "Card payment"},
];

const invoiceStatuses = [
    {id: 1, name: "Подготовлен"},
    {id: 2, name: "Создан"},
    {id: 3, name: "На согласовании"},
    {id: 4, name: "Согласован"},
    {id: 5, name: "Не согласован"},
    {id: 6, name: "Отправлен"},
    {id: 7, name: "Подписан"},
    {id: 8, name: "Отклонен"},
    {id: 9, name: "Сторнирован"},
];

const taskTypes = [
    {id: 1, name: "Инциденты"},
    {id: 2, name: "Клининг"},
];

const paymentTypes = [
    {id: 0, name: "Все"},
    {id: 1, name: "Аванс"},
    {id: 2, name: "Кредит"},
];


const state: State = {
    countryId: "",
    phone: "",
    userId: "",
    userName: "",
    token: "",
    userProfile: "",
    currentDocId: 0,
    currentInvoice: null,
    searchDocId: null,
    searchBrand: "",
    docs: [],
    searchCount: 0,
    countries: countries,
    landCountries: landCountries,
    invoiceTypes: invoiceTypes,
    invoiceStatuses: invoiceStatuses,
    taskTypes: taskTypes,
    paymentTypes: paymentTypes,
};


export default new Vuex.Store({
    state,

    getters: {
        isAuthenticated: state => (state.token !== ""),
        isAdmin: state => (state.userId == "10" || state.userId == "20" || state.userId == "121864"),
        isSuperAdmin: state => (state.userId == "10" || state.userId == "120479"),
        // isAdmin: state => (state.userId == "20"),
        isSalesOnly: state => (state.userId == "40870" || state.userId == "61992"),
        // isDocEditAllowed: state => (state.userId == "120479"),
        isDocEditAllowed: state => (
            state.userId == "10" || // Ершов
            state.userId == "120479" || //Голикова Валерия
            state.userId == "15026" || // Гулина Наталья
            state.userId == "271076" || // Терёхина Полина
            state.userId == "147010" || // Смурова Алена
            state.userId == "70763" || // Ямбулатов	Руслан
            state.userId == "143161" || // Шипилова Вероника
            state.userId == "112880" || // Тусургалиев Рустам
            false
        ),
        isBonusViewAllowed: state => (
            state.userId == "10" || // Ершов
            state.userId == "20" || // Шипилов
            state.userId == "56" || // Дядиченко
            state.userId == "32721" || // Учватов
            state.userId == "16943" || // Алексеенко
            state.userId == "19123" || // Чиркова
            state.userId == "120570" || // Гурбанов
            state.userId == "159768" || // Боровлев
            state.userId == "1358" || // Крайсберг
            state.userId == "1820" || // Попов
            state.userId == "45419" || // Морозов Артём
            state.userId == "175679" || // Фейзуллов Рафаэль
            state.userId == "59058" || // Зибарев Сергей
            state.userId == "38768" || // Ряполов
            state.userId == "37785" || // Джабарова
            state.userId == "206765" || // Матвеев
            state.userId == "165916" || // Ведерников
            state.userId == "206650" || // Хрипков Павел
            state.userId == "50091" || // Зибарев Сергей
            state.userId == "275068" || // Купаев Игорь
        false
        ),
        docs: state => state.docs,
        countries: state => state.countries,
        landCountries: state => state.landCountries,
        invoiceTypes: state => state.invoiceTypes,
        invoiceStatuses: state => state.invoiceStatuses,
        taskTypes: state => state.taskTypes,
        paymentTypes: state => state.paymentTypes,
        userName: state => state.userName,
    },

    mutations: {
        login(state, authData) {
            state.countryId = authData.countryId;
            state.phone = authData.phone;
            state.userId = authData.userId;
            state.userName = authData.userName;
            state.token = authData.token;

            axios.defaults.headers.authorization = state.token;

            localStorage.setItem('countryId', state.countryId);
            localStorage.setItem('userId', state.userId);
            localStorage.setItem('userName', state.userName);
            localStorage.setItem('token', state.token);

            // this.$route.push('/invoices')

        },
        logout(state) {
            state.countryId = "";
            state.phone = "";
            state.userId = "";
            state.userName = "";
            state.token = "";

            localStorage.removeItem('countryId');
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('token');
        },
        setDocs(state: State, invoices: Doc[]) {
            state.docs = invoices;
        },
        setUserData(state, userProfile) {
            state.userProfile = userProfile;
        },
    },

    actions: {
        login({commit}, authData) {
            // console.log(authData);
            // console.log(process.env.VUE_APP_ROOT_API);

            return new Promise((resolve, reject) => {
                axios.post('/auth', {
                    countryID: authData.countryID,
                    phone: authData.phone,
                    password: authData.password,
                    // password: md5(authData.password)
                })
                    .then((res) => {
                        console.log(res);

                        if (res.data.authToken) {
                            const authDataResult = {
                                landCountryID: authData.countryId,
                                phone: authData.phone,
                                userId: res.data.userId,
                                token: res.data.authToken,
                                userName: res.data.userName,
                            };
                            commit('login', authDataResult);
                        }
                        resolve(true);
                    })
                    .catch(error => {
                        reject((typeof error.response !== 'undefined') ? error.response.data : error.message);
                    });
            });
        },

        autoLogin({commit}) {

            const countryId = localStorage.getItem('countryId');
            const userId = localStorage.getItem('userId');
            const userName = localStorage.getItem('userName');
            const token = localStorage.getItem('token');

            if (countryId && userId && token) {
                commit('login', {
                    countryID: countryId,
                    phone: '',
                    userId: userId,
                    userName: userName,
                    token: token,
                });
            }
        },

        logout({commit}) {
            commit('logout');
        },
        setDocs({commit}) {
            axios.defaults.headers.authorization = state.token;
            axios.get('/invoices-by-filter')
                .then((res) => {
                    console.log(res.data);
                    commit('setDocs', res.data);
                })
                .catch(error => console.log(error));
        },
        setDocsById({commit}, params) {
            state.searchCount++;

            state.searchDocId = params.doc_id;
            state.searchBrand = params.brand;

            const current_id = state.searchCount;

            // // var client = new InvoiceClient('http://localhost:50052');
            // var client = new InvoiceClient('https://wowworks.app:50052');
            //
            // let req = new InvoiceSearchRequest();
            //
            // req.setCountryId(params.countryId);
            // req.setNumber(state.searchDocId);
            // req.setCustomerName(state.searchBrand);
            //
            //
            // client.search(req, null, (err, response) => {
            //
            //     console.log("GRPC-WEB TEST");
            //     console.log(err);
            //
            //     let data = response.getResultsList();
            //
            //     let inv = data[0].toObject();
            //
            //     console.log(inv.id);
            //     console.log(inv.franchiseName);
            //     // console.log(data);
            //
            //     commit('setDocs', data);
            //
            // });

            axios.defaults.headers.authorization = state.token;
            axios.get('/invoices-by-filter', {
                params: {
                    countryID: state.searchDocId,
                    brand: state.searchBrand,
                    country_id: params.countryId,
                    type_id: params.typeId,
                    customer_id: params.customerId,
                    legal_entity_id: params.legalEntityId,
                    department_id: params.departmentId,
                    branch_id: params.branchId,
                    signer_id: params.signerId,
                    status: params.status,
                },
            })
                .then((res) => {
                    if (current_id === state.searchCount) {
                        // console.log(res.data);
                        commit('setDocs', res.data);
                    } else {
                        console.log(`Search request aborted: ${current_id}`);
                    }
                })
                .catch(error => console.log(`Error: ${error}`));
        },
        setCurrentDocId({commit}, docId) {
            state.currentDocId = docId;
        },
        setCurrentInvoice({commit}) {
            axios.get('/doc_by_id', {
                params: {
                    invoice_id: state.currentDocId,
                    country_id: state.countryId,
                }
            })
                .then((res) => {
                    console.log(res.data);
                    state.currentInvoice = res.data;
                    // document.title = state.currentInvoice ? state.currentInvoice.id.toString() : '';
                })
                .catch(error => console.log(error));
        },

    },
})
